/* LP-only progressive interactions. Native buttons also support keyboard activation. */
(function () {
  'use strict';
  if (window.mwLpInteractionsLoaded) return;
  window.mwLpInteractionsLoaded = true;

  function init(scope) {
    scope.querySelectorAll('[data-disclosure], [data-lp-faq] .faq-item').forEach(function (item) {
      if (item.dataset.lpReady) return;
      item.dataset.lpReady = 'true';
      var trigger = item.querySelector('[data-disclosure-toggle], [data-faq-q]');
      var panel = item.querySelector('[data-disclosure-body], .faq-a');
      panel.inert = true;
      function resize() {
        if (item.classList.contains('open')) panel.style.maxHeight = panel.scrollHeight + 40 + 'px';
      }
      trigger.addEventListener('click', function () {
        var open = item.classList.toggle('open');
        trigger.setAttribute('aria-expanded', String(open));
        panel.inert = !open;
        panel.style.maxHeight = open ? panel.scrollHeight + 40 + 'px' : '0';
        panel.style.opacity = open ? '1' : '0';
      });
      panel.querySelectorAll('img').forEach(function (img) { img.addEventListener('load', resize); });
      window.addEventListener('resize', resize, { passive: true });
    });

    scope.querySelectorAll('[data-lp-reviews]').forEach(function (section) {
      if (section.dataset.lpReady) return;
      section.dataset.lpReady = 'true';
      var cards = Array.from(section.querySelectorAll('.hm-reviews__card'));
      function measure(card) {
        var wrap = card.querySelector('.hm-reviews__cardImg');
        var img = wrap.querySelector('img');
        if (wrap.dataset.tall || !img.naturalWidth || !img.clientWidth || img.naturalHeight / img.naturalWidth * img.clientWidth <= 360) return;
        wrap.dataset.tall = 'true';
        wrap.classList.add('is-collapsed');
        var fade = document.createElement('div');
        fade.className = 'hm-reviews__cardFade';
        fade.setAttribute('aria-hidden', 'true');
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'hm-reviews__cardMore';
        more.setAttribute('aria-expanded', 'false');
        more.innerHTML = 'Ganze Rezension lesen <svg width="12" height="12" aria-hidden="true"><use href="#mwlp-ic-arrow"></use></svg>';
        var less = document.createElement('button');
        less.type = 'button';
        less.className = 'hm-reviews__cardLess';
        less.textContent = '↑ Weniger anzeigen';
        less.hidden = true;
        wrap.append(fade, more);
        card.append(less);
        more.addEventListener('click', function () {
          wrap.classList.remove('is-collapsed');
          more.setAttribute('aria-expanded', 'true');
          more.hidden = fade.hidden = true;
          less.hidden = false;
          less.focus({ preventScroll: true });
        });
        less.addEventListener('click', function () {
          wrap.classList.add('is-collapsed');
          more.setAttribute('aria-expanded', 'false');
          more.hidden = fade.hidden = false;
          less.hidden = true;
          more.focus({ preventScroll: true });
        });
      }
      cards.forEach(function (card) {
        var img = card.querySelector('img');
        if (img.complete) measure(card);
        img.addEventListener('load', function () { measure(card); });
      });
      section.querySelector('[data-rev-more-btn]').addEventListener('click', function () {
        cards.forEach(function (card) { card.classList.remove('is-hidden'); measure(card); });
        section.querySelector('[data-rev-more]').hidden = true;
      });
      window.addEventListener('resize', function () { cards.forEach(measure); }, { passive: true });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
